import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../shared/material.module';
import { LargeShareholderCategory } from '../../../models/largeShareholderCategory';
import { LutService } from '../../../services/lut.service';
import { AddPyramidItemComponent } from "../add-pyramid-item/add-pyramid-item.component";
import { AddPyramidSearchConnectComponent } from "../add-pyramid-search-connect/add-pyramid-search-connect.component";

export interface AddPyramidDialogData {
  largeShareholderId: string;
  year: number;
}

type DialogMode = 'add-new' | 'search-connect';

@Component({
  selector: 'app-add-pyramid-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MaterialModule,
    AddPyramidItemComponent,
    AddPyramidSearchConnectComponent
],
  templateUrl: './add-pyramid-dialog.component.html',
  styleUrls: ['./add-pyramid-dialog.component.scss']
})
export class AddPyramidDialogComponent implements OnInit {
  @ViewChild(AddPyramidItemComponent) addPyramidItemComponent!: AddPyramidItemComponent;
  @ViewChild(AddPyramidSearchConnectComponent) addPyramidSearchConnectComponent!: AddPyramidSearchConnectComponent;

  currentMode: DialogMode = 'search-connect';
  isAddNewItemFormValid: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddPyramidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddPyramidDialogData
  ) {
  }

  ngOnInit(): void {}

  onAddNewFromSearch(): void {
    this.currentMode = 'add-new';
    this.isAddNewItemFormValid = false;
  }

  onBack(): void {
    this.currentMode = 'search-connect';
    this.isAddNewItemFormValid = false;
  }

  onConfirm(): void {
    if (this.currentMode === 'add-new') {
      this.addPyramidItemComponent.onConfirm();
    } else if (this.currentMode === 'search-connect') {
      this.addPyramidSearchConnectComponent.addPyramidItemComponent.onConfirm();
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  getDialogTitle(): string {
    switch (this.currentMode) {
      case 'add-new':
        return 'Add New Pyramidal Shareholder';
      case 'search-connect':
        return 'Add New Pyramid Item';
      default:
        return 'Add New Pyramid Item';
    }
  }

  onFormValidityChange(isValid: boolean) {
    this.isAddNewItemFormValid = isValid;
  }

}
